import { useEffect } from 'react'
import { type NexiRetrievePaymentResponse } from 'ecosystem'
import { NexiCheckout } from '../NexiCheckout'

type NexiConfirmationProps = {
  nexiData: NexiRetrievePaymentResponse
  onConfirmPurchase: () => void
}

export const NexiConfirmation = ({ nexiData, onConfirmPurchase }: NexiConfirmationProps) => {
  useEffect(() => {
    if (!nexiData) {
      return
    }

    onConfirmPurchase()
  }, [nexiData, onConfirmPurchase])

  if (!nexiData) {
    return null
  }

  return <NexiCheckout nexiPaymentId={nexiData.payment.paymentId} />
}
